'use strict';

/**
 * This service acts a mediator for delegating global
 * basket update events. Global events are required due
 * to different modules within the site needing to
 * communicate, but cannot do so due to differing scopes.
 */

module.exports = /*@ngInject*/
function CartService(
    $
) {
    var cartEvent = 'cart:basket:refresh';
    var cartSelectors = '#header-container, .rwd-page-header, .header-grid-right';
    var notificationEvent = 'cart:basket:notification';

    return {
        /**
         * Adds a handler to cart update events
         * @param  {Function} handler Cart update handler
         * @return {Object}         jQuery selector object for the cart elements
         */
        onCartUpdate: function(handler) {
            return $(cartSelectors)
                .on(cartEvent, handler);
        },

        /**
         * Adds a handler to cart notification events
         * @param  {Function} handler Cart notification handler
         * @return {Object}         jQuery selector object for the cart elements
         */
        onNotification: function(handler) {
            return $(cartSelectors)
                .on(notificationEvent, handler);
        },

        /**
         * Triggers a cart notification event
         * @param  {Object} data Data to be passed to the handler
         * @return {Object}         jQuery selector object for the cart elements
         */
        showNotification: function(data) {
            return $(cartSelectors)
                .trigger(notificationEvent, data);
        },

        /**
         * Triggers a cart update event
         * @param  {Object} data Data to be passed to the handler
         * @return {Object}         jQuery selector object for the cart elements
         */
        updateCart: function(data) {
            return $(cartSelectors)
                .trigger(cartEvent, data);
        }
    };
};
